export const BENCHMARK_BANDS = [
  { id: 'poor', min: 0, max: 19, tone: 'danger' },
  { id: 'belowAvg', min: 20, max: 39, tone: 'accent' },
  { id: 'average', min: 40, max: 59, tone: 'warning' },
  { id: 'good', min: 60, max: 79, tone: 'successSoft' },
  { id: 'excellent', min: 80, max: 100, tone: 'success' },
] as const

export type BenchmarkBand = (typeof BENCHMARK_BANDS)[number]['id']
export type BenchmarkBandDefinition = (typeof BENCHMARK_BANDS)[number]

/** Resolve the five legacy percentile bands at their exact inclusive boundaries. */
export function benchmarkBandOf(value: number): BenchmarkBand {
  const percentile = Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 0
  return (
    BENCHMARK_BANDS.find((band) => percentile >= band.min && percentile <= band.max) ??
    BENCHMARK_BANDS[0]
  ).id
}
